import { IS_SEND_GET_MOBILE_EMAIL_ENABLED } from '@/features/flags/legacy-flags';
import { useMutateSendGetMobileEmail } from '@/hooks/mutation/useMutateSendGetMobileEmail';
import { trackMobileAppDownloadModalViewed } from '@/models/analytics/features/trackMobileAppDownloadAnalytics';
import { HeidiLogoMark } from '@heidi/design-system/heidi-logo-mark';
import { GetMobileAppModal } from '@heidi/growth';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/**
 * The app half of the "Get Heidi on mobile" modal.
 *
 * `@heidi/growth` renders the surface and owns the open→closed→open decision;
 * everything app-shaped is bound here — the brand mark (a `next/image` slot),
 * the `/get-mobile` URL (`router.basePath` never crosses), the PostHog flag as
 * a thunk so a mid-session flip is still seen, the send-link mutation, and the
 * `modal_viewed` emit.
 */
export const GetMobileAppModalHost = () => {
  const router = useRouter();
  const { mutate: sendGetMobileEmail, isPending } = useMutateSendGetMobileEmail();

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const mobileLinkHref = `${origin}${router.basePath}/get-mobile`;

  const sendLink = useCallback(
    ({ onSuccess }: { onSuccess: () => void }) => {
      sendGetMobileEmail({ link: mobileLinkHref }, { onSuccess });
    },
    [sendGetMobileEmail, mobileLinkHref]
  );

  return (
    <GetMobileAppModal
      logo={<HeidiLogoMark artwork="standard" aria-label="Heidi" className="size-12" />}
      mobileLinkHref={mobileLinkHref}
      isSendEmailEnabled={IS_SEND_GET_MOBILE_EMAIL_ENABLED}
      sendLink={sendLink}
      isSendingLink={isPending}
      onModalViewed={trackMobileAppDownloadModalViewed}
    />
  );
};

GetMobileAppModalHost.displayName = 'GetMobileAppModalHost';
